export const canaryModalCopy = {};
